import React from 'react';
import {
  Button,
  Icon,
  P,
  Popover,
  Stack,
} from '@fashionnovateam/nova-ui-toolkit';

type SubmitAllPopoverProps = {
  selectedCount: number;
  onConfirm: () => void;
  isSubmitting?: boolean;
};

export function SubmitAllPopover({
  selectedCount,
  onConfirm,
  isSubmitting = false,
}: SubmitAllPopoverProps) {
  return (
    <Popover position="bottom" offset={8}>
      {({ close }) => (
        <>
          <Popover.Button size="sm">
            <Icon name="check/check-tick-circle" />
            Submit All
          </Popover.Button>
          <Popover.Content className="bg-white border border-neutral-200 rounded-lg shadow-lg p-3 w-[236px]">
            <div className="flex flex-col gap-3">
              <P size="sm" weight="semibold">
                Submit {selectedCount} {selectedCount === 1 ? 'item' : 'items'}?
              </P>
              <P
                size="xs"
                color="disabled"
                className="min-w-0 whitespace-normal"
              >
                Please ensure the details are all double-checked and accurate.
              </P>
              <Stack direction="col" gap="sm">
                <Button
                  size="sm"
                  onClick={() => {
                    close();
                    onConfirm();
                  }}
                  disabled={selectedCount === 0 || isSubmitting}
                  className="w-full"
                >
                  Yes, Submit All
                </Button>
                <Button
                  size="sm"
                  color="secondary"
                  onClick={close}
                  className="w-full"
                >
                  Cancel
                </Button>
              </Stack>
            </div>
          </Popover.Content>
        </>
      )}
    </Popover>
  );
}
